import env from 'env'

export default {
  featureFlags: {
    instant_book: env.APP_ENV === 'development' || env.APP_ENV === 'staging',
  }
}
